import * as React from 'react';
import { Provider } from 'react-redux';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';

import { mountReactNode } from '@common/utils/react';
import { LookupTable } from './LookupTable';
import { createStore } from '@common/utils/redux';
import { lookupTableReducers } from './reducers';
import { lookupTableEN } from './translations/en';
import { lookupTableES } from './translations/es';
import { lookupTableJA } from './translations/ja';

export const initLookupTableApp = (
  componentId,
  tableFieldId,
  tableFieldContext,
  locale
) => {
  const store = createStore(lookupTableReducers);
  syncTranslationWithStore(store);

  const translation = {
    en: lookupTableEN,
    ja: lookupTableJA,
    es: lookupTableES,
  };

  if (!translation[locale]) {
    locale = 'en';
  }

  store.dispatch(loadTranslations(translation));
  store.dispatch(setLocale(locale));

  mountReactNode(
    <Provider store={store}>
      <LookupTable 
        tableMetadata={{
          tableFieldId,
          tableFieldContext,
        }}
      />
    </Provider>,
    document.getElementById(componentId)
  );
};
